import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class DocumentUploadService {
  private aadhaarFile: File | null = null;
  private aadhaarUrl: string | null = null;

  setAadhaar(file: File, url: string) {
    this.aadhaarFile = file;
    this.aadhaarUrl = url;
  }

  getAadhaar() {
    return { file: this.aadhaarFile, url: this.aadhaarUrl };
  }
}
